module.exports = __webpack_public_path__ + "97bd8bda14fd92a8191afa43ed71a48c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-3.png
// module id = 2141
// module chunks = 0